import axios from 'axios'
import endpoints from '@/api/endpoints'
import _ from 'lodash'

export default {
  async getInventoryForDivision (divID) {
    return axios.get(endpoints.inventory + '?division=' + divID).then((response) => {
      return _.orderBy(response.data, 'number')
    })
  },
  async getInventory () {
    return axios.get(endpoints.inventory).then((response) => {
      return _.orderBy(response.data, 'number')
    })
  },
  async getInventoryItem (itemID) {
    return axios.get(endpoints.inventory + itemID + '/').then((response) => {
      return response.data
    })
  },
  async updateInventoryItem (item) {
    return axios.patch(endpoints.inventory + item.id + '/', item).then((response) => {
      return response.data
    })
  },
  async newInventoryItem (item) {
    return axios.post(endpoints.inventory, item).then((response) => {
      return response.data
    })
  }
}
